import React, { useEffect } from "react";

import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";

import CertificationManual from "./components/manual";
import CertificationAuto from "./components/auto";
import {
  useSummaryCustoms
} from "../../../../../api/calc";
import {useDemoCertificationCompletion} from 'components/cabinet/demo/steps/certification/use-certification';
import {useCalculationReadOnly} from '../../calculation-read-only';

export const enum CertificationType {
  MANUAL = 'MANUAL',
  AUTO = 'AUTO',
  NONE = 'NONE'
}

type Props = {
  handleComplete(): void
}

const Certification = ({handleComplete}: Props) => {

  const [ value, setValue ] = React.useState<CertificationType>(CertificationType.NONE);
  const [ isManualExpanded, setIsManualExpanded ] = React.useState(false);
  const [ isAutoExpanded, setIsAutoExpanded ] = React.useState(false);

  const summaryCustoms = useSummaryCustoms();
  const readOnly = useCalculationReadOnly();
  useDemoCertificationCompletion(setIsManualExpanded, setIsAutoExpanded)

  useEffect(() => {
    if (summaryCustoms?.cert_total_manual) {
      setValue(CertificationType.MANUAL);
      setIsManualExpanded(true);
      setIsAutoExpanded(false);
    } else {
      setValue(CertificationType.AUTO);
      setIsManualExpanded(false);
      setIsAutoExpanded(true);
    }
  }, [ summaryCustoms ])

  const handleChangeRadioButton = (event: React.ChangeEvent<HTMLInputElement>) => {
    const certificationType = event.target.value as CertificationType;

    setValue(certificationType);

    if (certificationType === CertificationType.MANUAL) {
      setIsManualExpanded(true);
      setIsAutoExpanded(false);
    } else if (certificationType === CertificationType.AUTO) {
      setIsManualExpanded(false);
      setIsAutoExpanded(true);
    }
  };

  const handleChangeAccordion = (certType: CertificationType, isExpanded: boolean) => {
    if (readOnly) {
      if (certType === CertificationType.MANUAL) {
        setIsManualExpanded(isExpanded);
      } else if (certType === CertificationType.AUTO) {
        setIsAutoExpanded(isExpanded);
      }
      return;
    }

    setValue(certType);
    if (certType === CertificationType.MANUAL) {
      setIsManualExpanded(isExpanded);
      setIsAutoExpanded(false);
    } else if (certType === CertificationType.AUTO) {
      setIsManualExpanded(false);
      setIsAutoExpanded(isExpanded);
    }
  };

  return <FormControl sx={{ width: '100%' }}>
    <RadioGroup
      name='radio-buttons-certifications'
      value={value}
      onChange={readOnly ? undefined : handleChangeRadioButton}
    >
      <CertificationManual
        isExpanded={isManualExpanded}
        handleChangeAccordion={handleChangeAccordion}
        value={summaryCustoms?.cert_total_manual || undefined}
        handleComplete={handleComplete}
        handleChange={() => setValue(CertificationType.MANUAL)}
        isActive={value === CertificationType.MANUAL}
      />
      <CertificationAuto
        isExpanded={isAutoExpanded}
        handleChangeAccordion={handleChangeAccordion}
        value={!summaryCustoms?.cert_total_manual ? summaryCustoms?.cert_total : undefined}
        handleComplete={handleComplete}
        handleChange={() => setValue(CertificationType.AUTO)}
        isActive={value === CertificationType.AUTO}
      />
    </RadioGroup>
  </FormControl>
}

export default Certification
